module.exports = __webpack_public_path__ + "img/nifty-logo.33ca2f60.svg";